import { useCallback } from 'react'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_DELETE_API_KEY_SERVER } from '@/app/module/user/definitions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDeleteAuthToken = () => {
  const dispatch = useAppDispatch()
  const [mutate, res] = esApi.useDeleteUserAuthTokenMutation()

  const deleteToken = useCallback(
    async (tokenId: number) => {
      try {
        await mutate({ tokenId }).unwrap()
        return true
      } catch (e) {
        dispatch(
          createNotification({
            'delete-api-key-error': {
              type: 'error',
              message: getErrorMessage(e, ERROR_DELETE_API_KEY_SERVER),
            },
          }),
        )
        return false
      }
    },
    [mutate, dispatch],
  )

  return [deleteToken, res] as const
}
